import axios from "axios";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Table } from "reactstrap";
import { ServiceThreadSpinner, SortHeader } from ".";
import { api, constants } from "../utils";

export default function InventoryDashBoardCustomersGrid(props) {
   const {
      selectedItem,
      customersSortField,
      customersSortDirection
   } = props.params;

   const [data, setData] = useState([]);
   const [loaded, setLoaded] = useState(false);
   const [params, setParams] = useState({});
   const payload = {
      ItemNumber: selectedItem?.value,
      CustomersSortDirection: customersSortDirection,
      CustomersSortField: customersSortField
   }

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      if (props.params.selectedItem?.value !== params.selectedItem?.value) {
         setParams(props.params)
         setLoaded(false); //for the spinner
      }
      api
         .postS('Inventory/Customers', payload, source.token)
         .then(response => {
            if (response.data.success) {
               const dataResponse = response.data.itemGrid.customers
               setData(dataResponse);
               //set total here if its there
            } else {
               throw new Error(response);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setLoaded(true));

      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.params])

   return (
      <>
         <Card className="dashboard-card">
            <CardBody>
               <div>
                  <span className="h2 me-2">Associated Customers</span>
               </div>
               <hr />
               <ServiceThreadSpinner on={!loaded}>
                  {loaded && data.length !== 0 ?
                     <Table size="sm" className="data-table">
                        <thead className="table-header">
                           <tr>
                              <th style={{ width: "35%" }}>
                                 <SortHeader
                                    displayName={"Customer"}
                                    field={"CustomerName"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "CustomerName"}
                                    callback={props.sortCallback}
                                    state={{
                                       customersSortField: "CustomerName",
                                       customersSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.Customers,
                                    }}
                                 />
                              </th>
                              <th style={{ width: "35%" }}>
                                 <SortHeader
                                    displayName={"Customer PN"}
                                    field={"CustomerItemNumber"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "CustomerItemNumber"}
                                    callback={props.sortCallback}
                                    state={{
                                       customersSortField: "CustomerItemNumber",
                                       customersSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.Customers,
                                    }}
                                 />
                              </th>
                              <th style={{ width: "15%" }}>
                                 <SortHeader
                                    displayName={"3 Month Qty"}
                                    field={"QtrSalesQty"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "QtrSalesQty"}
                                    callback={props.sortCallback}
                                    state={{
                                       customersSortField: "QtrSalesQty",
                                       customersSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.Customers,
                                    }}
                                 />
                              </th>
                              <th style={{ width: "15%" }}>
                                 <SortHeader
                                    displayName={"Avg Month Usage"}
                                    field={"AvgMonthlyUsage"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "AvgMonthlyUsage"}
                                    InvDBtype={constants.INVENTORYDASHBOARD_TYPES.Customers}
                                    callback={props.sortCallback}
                                    state={{
                                       customersSortField: "AvgMonthlyUsage",
                                       customersSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.Customers,
                                    }}
                                 />
                              </th>
                           </tr>
                        </thead>
                        <tbody>
                           {_.map(data, (datum, index) => {
                              return (
                                 <tr key={index} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                                    <td>
                                       <Link
                                          style={{ textDecoration: "none" }}
                                          className="shredLink fw-bold"
                                          to={`/customer-dashboard/${datum.customerNumber}`}
                                       >
                                          {datum.customerName}
                                       </Link>
                                    </td>
                                    <td className="data-cell" children={datum.customerItemNumber} />
                                    <td className="data-cell" children={Math.round(datum.qtrSalesQty).toLocaleString()} />
                                    <td className="data-cell" children={Math.round(datum.avgMonthlyUsage).toLocaleString()} />
                                 </tr>
                              );
                           })}
                        </tbody>
                        <tfoot className="table-footer">
                           <tr></tr>
                        </tfoot>
                     </Table>
                     :
                     <div>
                        <span>No Associated Customers found</span>
                     </div>
                  }
               </ServiceThreadSpinner>
            </CardBody>
         </Card>
      </>
   );
}
